// ============================================================================
// PageTransition — envoltorio de transición entre pantallas (Framer Motion)
// Fade + leve desplazamiento vertical, con curva "premium" (easeOutExpo-ish).
// Respeta prefers-reduced-motion: si el usuario lo pide, no anima.
// ============================================================================

import React from 'react';
import { m, useReducedMotion } from 'framer-motion';

// Curva suave tipo easeOutExpo: arranque rápido, frenada elegante.
const EASE = [0.22, 1, 0.36, 1];

export default function PageTransition({ children, className }) {
  const reduce = useReducedMotion();

  const variants = reduce
    ? {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      }
    : {
        initial: { opacity: 0, y: 10 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -8 },
      };

  return (
    <m.div
      data-motion-fallback
      className={className}
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: reduce ? 0.15 : 0.32, ease: EASE }}
      style={{ height: '100%' }}
    >
      {children}
    </m.div>
  );
}
